var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#341FFF",
    clipPath: "url(#link_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.998 2.216 9.917 7.298q-.013.015-.026.031a7.34 7.34 0 0 1 3.73.408l3.449-3.45a2.933 2.933 0 0 1 4.143 0 2.93 2.93 0 0 1 0 4.144l-5.082 5.081c-1.151 1.152-3.04 1.103-4.143 0-.57-.57-1.5-.57-2.071 0l-.89.89c.247.419.53.822.89 1.182 2.17 2.17 5.905 2.343 8.255.026q.016-.013.031-.026l5.082-5.081a5.86 5.86 0 0 0-8.287-8.287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.39 18.252-3.459 3.46a2.933 2.933 0 0 1-4.143 0 2.933 2.933 0 0 1 0-4.143l5.092-5.093c1.152-1.151 3.041-1.102 4.143 0 .571.571 1.501.571 2.072 0l.89-.89a5.8 5.8 0 0 0-.89-1.181c-2.166-2.166-5.898-2.35-8.255-.026q-.015.013-.031.026l-5.093 5.092a5.86 5.86 0 1 0 8.287 8.287l5.092-5.093c.01-.01.016-.021.026-.031a7.34 7.34 0 0 1-3.73-.408"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "link_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h25v25H0z"
  })))));
};
export { SvgLink as ReactComponent };